export default __webpack_public_path__ + "static/media/Icon-search.7a892bf9.svg";